import React from 'react';
import redial from 'redial';

import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/Static/components/Page';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/Static/redial';

import {inject} from '@aboutyou/legacy-desktop/src/app/helpers/mobx';
import {PageTrackingContextProvider} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/PageTrackingContext';
import {useTrackingPageUrl} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/hooks/useTrackingPageUrl';
import {TrackingPageTypeWithoutId} from '@aboutyou/legacy-tracking-sdk';
import {LegacyDesktopStyles} from '../styles/LegacyBaseStyles';

const StaticPageConnected = inject(
  store => {
    return {
      pageType: store.staticPageStore.currentStaticPage,
      staticContent: store.staticPageStore.currentPageContent,
      staticJsonLd: store.staticPageStore.currentJsonLd,
    };
  },
  {observe: true},
)(Page);

const TrackedStaticPage = () => {
  const {path, search} = useTrackingPageUrl();

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.Other}
    >
      <div className={LegacyDesktopStyles} />
      <StaticPageConnected />
    </PageTrackingContextProvider>
  );
};

const PageWithRedial = redial.provideHooks(redialHandle)(() => (
  <TrackedStaticPage />
));

export const LegalPage = withLegacyProviders(PageWithRedial);
